import { Button, cn, ListBox, Select } from "@heroui/react";
import { ChevronLeft, ChevronRight } from "lucide-react";

const PAGE_SIZE_OPTIONS = ["10", "20", "50", "100"];

const TablePagination = ({ table, pageSize = '10', setPageSize, totalRows, noun = "records" }) => {
  const { pageIndex, pageSize: currentPageSize } = table.getState().pagination;
  const from = pageIndex * currentPageSize + 1;
  const to = Math.min(from + currentPageSize - 1, totalRows);

  return (
    <div className="flex md:flex-row flex-col md:items-center md:gap-0 gap-4 justify-between px-3 py-2">
      <span className="text-xs text-muted">
        Showing {from} to {to} of {totalRows} {noun}
      </span>

      <div className="flex gap-4 md:flex-row flex-col md:items-center">
        <div className="flex items-center gap-2">
          <Button
            isIconOnly
            size="sm"
            variant="ghost"
            className="border rounded-lg disabled:opacity-40"
            onPress={() => table.previousPage()}
            isDisabled={!table.getCanPreviousPage()}
          >
            <ChevronLeft size={15} />
          </Button>

          {Array.from({ length: Math.min(table.getPageCount(), 5) }, (_, i) => (
            <Button
              key={i}
              size="sm"
              variant="ghost"
              className={cn("border rounded-lg", pageIndex === i && "border-2 border-accent")}
              onPress={() => table.setPageIndex(i)}
            >
              {i + 1}
            </Button>
          ))}

          <Button
            isIconOnly
            size="sm"
            variant="ghost"
            className="border rounded-lg disabled:opacity-40"
            onPress={() => table.nextPage()}
            isDisabled={!table.getCanNextPage()}
          >
            <ChevronRight size={15} />
          </Button>
        </div>

        <Select
          className="w-36"
          aria-label="Rows per page"
          selectedKey={String(pageSize)}
          onSelectionChange={(key) => {
            const val = Number(key);
            setPageSize(val);
            table.setPageSize(val);
          }}
        >
          <Select.Trigger className={'shadow-none border border-muted/20'}>
            <Select.Value />
            <Select.Indicator />
          </Select.Trigger>
          <Select.Popover>
            <ListBox>
              {PAGE_SIZE_OPTIONS.map((s) => (
                <ListBox.Item key={s} id={s} textValue={`${s} per page`}>
                  {s} per page
                  <ListBox.ItemIndicator />
                </ListBox.Item>
              ))}
            </ListBox>
          </Select.Popover>
        </Select>
      </div>
    </div>
  );
};

export default TablePagination;